import {
  createEntityAdapter,
  createSlice,
  configureStore,
} from '@reduxjs/toolkit'

const adapter = createEntityAdapter()


const billingDataSlice = createSlice({
  name: 'billingData',
  initialState: {
    creditTopUps: [],
    creditUsages: [],
  },
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload }),
  },
})
const usageDataSlice = createSlice({
  name: 'usageData',
  initialState: {
    "textMessages": [],
    "whatsappMessages": [],
    "calls": [],
    "transferCalls": [],
    "emails": [],
    "costs": {},
  },
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload }),
  },
})

const store = configureStore({
  reducer: {
    billingData: billingDataSlice.reducer,
    usageData: usageDataSlice.reducer,
  },
  devTools: {
    name: 'Manage billing',
  },
})

export default store
